import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TSDEditData, TSDListItem } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useUpdateTSD = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ tsd, refreshCustomerData }: TSDEditData): Promise<TSDListItem> => {
      const result = await apiClient.tsd.updateTsd.mutation({ body: { tsd, refreshCustomerData } });
      if (result.status !== 200) throw result.body;
      return result.body.data.updatedTsd as TSDListItem;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storage', data._id] });
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      toast.success('TSD saved successfully!');
    },
    onError: (error) => {
      const originalError = (error as any).response?.data?.originalError;
      showErrorToast(error, originalError || 'Error saving the TSD!');
    },
  });
};
